import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { HeroVisual } from './ui/AbstractVisuals';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center px-4 overflow-hidden pt-20" data-id="element-48">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-neon-cyan/10 rounded-full blur-[120px] pointer-events-none" data-id="element-49" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-electric-violet/10 rounded-full blur-[120px] pointer-events-none" data-id="element-50" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-51">
        {/* Text Content */}
        <div className="text-left space-y-8" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-53">
            
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight tracking-tight" data-id="element-54">
              Fikirleri <br data-id="element-55" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-electric-violet" data-id="element-56">
                Hayalden
              </span>{' '}
              Gerçeğe <br data-id="element-57" />
              Dönüştürüyoruz.
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-400 max-w-xl leading-relaxed" data-id="element-58">
            Mücevherattan sağlığa, oyun dünyasından otomotive... Farklı
            sektörlerde ses getirecek kendi platformlarımızı, kendi vizyonumuzla
            inşa ediyoruz.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-59">
            <Link to="/hakkimizda" data-id="element-60">
              <Button variant="primary" icon data-id="element-61">
                Vizyonumuz
              </Button>
            </Link>
            <Link to="/iletisim" data-id="element-62">
              <Button variant="secondary" data-id="element-63">İletişim</Button>
            </Link>
          </motion.div>
        </div>

        {/* Visual Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1
      }} className="relative" data-id="element-64">
          <HeroVisual data-id="element-65" />
        </motion.div>
      </div>
    </section>;
}